// extracted by mini-css-extract-plugin
module.exports = {"container":"SleepDuration_container__2VlxU","icon":"SleepDuration_icon__f378Q"};